export class NameValueGenericStruct {
    public id: number;
    public name: string;
    public value: string;
}